import { render, staticRenderFns } from "./InvoiceDetail.vue?vue&type=template&id=63c9fc72&scoped=true&"
import script from "./InvoiceDetail.vue?vue&type=script&lang=js&"
export * from "./InvoiceDetail.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceDetail.vue?vue&type=style&index=0&id=63c9fc72&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63c9fc72",
  null
  
)

export default component.exports